import React from 'react';

const Direction = (props) => (
  <svg 
    width="15" 
    height="24" 
    viewBox="0 0 15 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M12.9221 2L2 12L12.9221 22" stroke="url(#paint0_linear)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <defs>
      <linearGradient id="paint0_linear" x1="2" y1="2" x2="17.6183" y2="6.83727" gradientUnits="userSpaceOnUse">
        <stop stop-color="#C8D8E1"/>
        <stop offset="1" stop-color="#AABAC5"/>
      </linearGradient>
    </defs>
  </svg>

);

export default Direction;
